import {
  getCurrentUserNetwork,
  getCurrentUserNetworkById,
  getCurrentUserNetworks,
  getCurrentUserNetworksStatus,
  getOtherNetworksUnreadCount,
  isCurrentNetworkExternal,
} from '@ms/yammer-data/dist/domains/currentUserNetworks/selectors';

import { useSelector } from '../useSelector';

type UseCurrentUserNetwork = () => ReturnType<typeof getCurrentUserNetwork>;
/**
 * @deprecated PERFORMANCE This returns an entity object and forces unnecessary re-renders.
 * This should be replaced by a `useCurrentUserNetworkField` selector.
 */
export const useCurrentUserNetwork: UseCurrentUserNetwork = () => useSelector(getCurrentUserNetwork);

type UseCurrentUserNetworks = () => ReturnType<typeof getCurrentUserNetworks>;
/**
 * @deprecated PERFORMANCE This returns a list of entity objects and forces unnecessary re-renders for
 * this consumer's entire component tree. Consumers should select a list of ids, then pass each id
 * to a child component to select the specific network fields they require.
 */
export const useCurrentUserNetworks: UseCurrentUserNetworks = () => useSelector(getCurrentUserNetworks);

type UseCurrentUserNetworkById = (networkId: string) => ReturnType<typeof getCurrentUserNetworkById>;
/**
 * @deprecated PERFORMANCE This returns an entity object and forces unnecessary re-renders.
 * This should be replaced by a `useCurrentUserNetworkByIdField` selector.
 */
export const useCurrentUserNetworkById: UseCurrentUserNetworkById = (networkId) =>
  useSelector((state) => getCurrentUserNetworkById(state, networkId));

type UseCurrentUserNetworksStatus = () => ReturnType<typeof getCurrentUserNetworksStatus>;
export const useCurrentUserNetworksStatus: UseCurrentUserNetworksStatus = () =>
  useSelector(getCurrentUserNetworksStatus);

type UseOtherNetworksUnreadCount = () => ReturnType<typeof getOtherNetworksUnreadCount>;
export const useOtherNetworksUnreadCount: UseOtherNetworksUnreadCount = () => useSelector(getOtherNetworksUnreadCount);

type UseHasOtherNetworksUnreadContent = () => boolean;
export const useHasOtherNetworksUnreadContent: UseHasOtherNetworksUnreadContent = () =>
  useOtherNetworksUnreadCount() > 0;

type UseIsCurrentNetworkExternal = () => boolean;
export const useIsCurrentNetworkExternal: UseIsCurrentNetworkExternal = () => useSelector(isCurrentNetworkExternal);
